<template>
	<div class="epmitDetail p-t-10">
		<img :src="epmit" alt="" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				epmit: require('@/assets/image/epmit.png'),
			}
		},
		methods: {
			getDate(id){
				let _self = this;
				
			}
		},
		mounted() {
			let _self = this;
			
		},
		created() {
			
		}
	};
</script>

<style lang="scss">
	.epmitDetail {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
		
		img{
			width: 900px;
			height: 900px;
			margin: 0 auto;
		}
	}
</style>